// src/hooks/useImagePreloader.js
import { useEffect, useRef } from 'react';

const imageCache = new Map();

export const useImagePreloader = (images) => {
  const loadedImages = useRef(new Set());

  useEffect(() => {
    if (!images || images.length === 0) return;

    const preloadImage = (src) => {
      if (!src || loadedImages.current.has(src) || imageCache.has(src)) return;

      const img = new Image();
      img.src = src;
      
      img.onload = () => {
        imageCache.set(src, true);
        loadedImages.current.add(src);
      };
      
      img.onerror = () => {
        console.error(`Failed to preload image: ${src}`);
      };
    };

    // Précharger toutes les images
    images.forEach(preloadImage);
  }, [images]);

  return imageCache;
};

export const isImageCached = (src) => imageCache.has(src);